import React from "react";
import { Box, Grid, GridItem,  } from "@chakra-ui/react";
import JewelleryCard from "./JewelleryCard";

export default function JewelleryGrid({ products = [] }) {


  const bg = [
    "#EFEAE2",
    "#F2EEE8",
    "#F7F5F1",
    "#FCFBF9",
    "#C0B7AB",
    "#CCC5BC",
    "#E0DBD4",
    "#F2F1EE",
  ];

  const firstTwo = products.slice(0, 2);
  const nextOne = products.slice(2, 3);
  const lastTwo = products.slice(3, 5);
  const remaining = products.slice(5);

  return (
    <Box>
      <Grid
        templateColumns={{
          base: "repeat(2,2fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(4, 1fr)",
        }}
      >
        {/* <GridItem
          display={{ base: "block", md: "none" }}
          colSpan={{ base: 1, sm: 2 }}
          rowSpan={{ base: 1, sm: 2 }}
        >
          {products?.map((product, index) => (
            <GridItem key={product._id}>
              <JewelleryCard
                image={product.images?.[0]}
                title={product.name}
                price={product.price?.[0]?.amount}
                props={{ bg: bg[index % bg.length] }}
              />
            </GridItem>
          ))}
        </GridItem> */}

        {firstTwo.map((product, i) => (
          <GridItem key={product._id}>
            <JewelleryCard
              products={product}
              images={product.images}
              title={product.name}
              price={product.price?.[0]?.amount}
              props={{ bg: bg[i % bg.length] }}
            />
          </GridItem>
        ))}
        {nextOne.length > 0 && (
          <GridItem
            colSpan={2}
            rowSpan={2}
            display={{ base: "none", md: "block" }}
          >
            <JewelleryCard
              products={nextOne[0]}
              images={nextOne[0].images}
              title={nextOne[0].name}
              price={nextOne[0].price?.[0]?.amount}
              props={{ bg: bg[2 % bg.length] }}
            />
          </GridItem>
        )}
        {lastTwo.map((product, i) => (
          <GridItem key={product._id}>
            <JewelleryCard
              products={product}
              images={product.images}
              title={product.name}
              price={product.price?.[0]?.amount}
              props={{ bg: bg[(i + 3) % bg.length] }}
            />
          </GridItem>
        ))}

        {remaining.map((product, i) => (
          <GridItem key={product._id}>
            <JewelleryCard
              products={product}
              images={product.images}
              title={product.name}
              price={product.price?.[0]?.amount}
              props={{ bg: bg[(i + 5) % bg.length] }}
            />
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
}
